import { z } from 'zod';

export const PremiumPurchaseStatusSchema = z.enum(['PENDING','ERROR','CANCELED','COMPLETE']);

export type PremiumPurchaseStatusType = `${z.infer<typeof PremiumPurchaseStatusSchema>}`

export default PremiumPurchaseStatusSchema;
